import { render } from "./DeleteAccountModal.vue?vue&type=template&id=6f87077c&scoped=true"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js"

import "./DeleteAccountModal.vue?vue&type=style&index=0&id=6f87077c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f87077c"]])

export default __exports__